import {  
  loadRemoteDeviceDataInProgress,
  loadRemoteDeviceDataSuccess,
  loadRemoteDeviceDataFailure,
  remoteDeviceOperationCompleted
} from "../state/remotedevice/actions";
import configData from "../config.json";

import { oopsSweetAlert } from '../components/SweetAlertMessages';
import { errorSweetAlert } from '../components/SweetAlertMessages';
import { oktaAuth } from '../auth/okta';

const serverBasePath=configData.SERVER_API_URL;

export const loadRemoteDevice = (searchText='', page=0,pageSize=10) => async (dispatch) => {
  const token = oktaAuth.getAccessToken(); 
  if (!token) throw new Error('No access token');
  try {
    dispatch(loadRemoteDeviceDataInProgress());
    const response = await fetch(serverBasePath+"/remote/device?searchText="+searchText+"&page="+page+"&pageSize="+pageSize,
      {
        method: "GET",
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
      }});
      if(response.status===401){
        window.location.reload(false);
        return;
      }
      const data = await response.json();
      dispatch(loadRemoteDeviceDataSuccess(data));
  } catch (e) {       
    dispatch(loadRemoteDeviceDataFailure());
    errorSweetAlert(e);
  }
};

export const downloadSocketLogFile = (rowId,fileName,fileType) =>  {
  return async (dispatch) => {
      const token = oktaAuth.getAccessToken();
      if (!token) throw new Error('No access token');
      try {
          dispatch(loadRemoteDeviceDataInProgress());
          const response = await fetch(serverBasePath+"/remote/"+rowId+"/"+fileType+"/download",
          {   
              method: "GET",
              headers: {
                  Authorization: 'Bearer ' + token,
              }
          });
          if(response.status === 500){
              dispatch(remoteDeviceOperationCompleted()); 
              const error = {'message': 'Internal Server Error'};
              oopsSweetAlert(error);
              return
          }
          const blob = await response.blob();
          const url  = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement('a');
          link.href  = url;
          link.setAttribute('download',fileName); 
          document.body.appendChild(link);
          link.click();
          dispatch(remoteDeviceOperationCompleted()); 
      } catch (e) {   
          dispatch(loadRemoteDeviceDataFailure());
          errorSweetAlert(e); 
      }
  };
};
